import { Loader } from "@googlemaps/js-api-loader"


let reviews = []

const init = () => {
    const loader = new Loader({
        apiKey: "AIzaSyB7TznHc_yjWGX9xNwXRkApyB1nxKO-CYQ",
        version: "weekly",
      });
      
      loader.load().then(async () => {
        const {Place} = await google.maps.importLibrary("places");
        const place = new Place({
            id: "ChIJ__9vOTbbwoARf4DPQIT_K-8", // Faneuil Hall Marketplace, Boston, MA
        });
        console.log("place: ", place)
          // Call fetchFields, passing 'reviews' and other needed fields.
        await place.fetchFields({
            fields: ["displayName", "formattedAddress", "location", "reviews"],
        });
        reviews = place.reviews.map(it => {
          return {name: it.authorAttribution.displayName, avatar: it.authorAttribution.photoURI, text: it.text}
        })
      });
}

const getReviews = () => {
  return new Promise((resolve, reject) => {
    const loader = new Loader({
      apiKey: "AIzaSyB7TznHc_yjWGX9xNwXRkApyB1nxKO-CYQ",
      version: "weekly",
    });
    
    loader.load().then(async () => {
      const {Place} = await google.maps.importLibrary("places");
      const place = new Place({
          id: "ChIJ__9vOTbbwoARf4DPQIT_K-8", // Faneuil Hall Marketplace, Boston, MA
      });
      console.log("place: ", place)
        // Call fetchFields, passing 'reviews' and other needed fields.
      await place.fetchFields({
          fields: ["displayName", "formattedAddress", "location", "reviews"],
      });
      reviews = place.reviews.map(it => {
        return {name: it.authorAttribution.displayName, avatar: it.authorAttribution.photoURI, text: it.text}
      })
      resolve(reviews)
    });
  })
}

export default {
    init,
    getReviews
}